import { Vue, Component, Prop } from 'vue-property-decorator';
import type { CreateElement, VNode } from 'vue';
import type { ElForm } from 'element-ui/types/form';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import { LINK_TYPE } from '../linkForm/linkForm';
import style from './style.vue';
import LinkForm from '@/views/components/linkForm/linkForm.vue';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils } from '@/util';
import { globalElement } from '@/library/utils/globalElement';

const isset = QinggerLibUtils.isset;
@DialogFactory
@Component({
  mixins: [style],
  components: {
    LinkForm,
  },
})
export default class AddKeyword extends IPSDialog {
  title = '添加/编辑搜索关键词';

  data: ItemObject = {};

  width = '700px';

  scroll = false;

  connectedClass = [];

  $refs: {
    keyForm: ElForm;
  };

  rule = {
    keyword: [{ required: true, validator: this.validatorKeyword, trigger: ['blur', 'change'] }],
    desc: [{ required: true, validator: this.validatorDesc, trigger: ['blur', 'change'] }],
  };

  validatorKeyword(rul, val, callback) {
    const tmpList = (`${val}`).trim().replace(/，/gi, ',').split(',');
    const repeatList = tmpList.filter((item, index, arr) => {
      return arr.indexOf(item, 0) === index;
    });
    if (!val || !(`${val}`).trim()) {
      callback(new Error(' '));
    }
    if (tmpList.length !== repeatList.length) {
      callback(new Error('请勿输入重复关键字'));
    } else {
      callback();
    }
  }

  validatorDesc(rul, val, callback) {
    if (!val.linkType) {
      this.$message.error('请选择链接');
      callback(new Error(' '));
    }
    if (val.linkType !== LINK_TYPE.SALE && !val.linkId) {
      callback(new Error(' '));
    } else {
      callback();
    }
  }

  onLinkChange(val) {
    this.data.desc = val;
  }

  async mounted() {
    this.connectedClass = await this.getAttributeList();
  }

  // 关联分类
  public getAttributeList(): Promise<any> {
    return IPSService.getAttributeList()
      .then((res) => {
        return isset(res, 'list') ? res.list : [];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  beforeConfirm() {
    this.$refs.keyForm.validate((result) => {
      if (result) {
        IPSService.siteKeywordSave({ postParams: this.data })
          .then((res) => {
            if (res) {
              this.$message.success('保存成功！');
              this.$emit('result', true);
              this.$emit('hidden');
            } else {
              this.confirmloading = false;
            }
          })
          .catch((error) => {
            this.confirmloading = false;
          });
      } else {
        this.confirmloading = false;
      }
    });
  }

  blurText() {
    this.data.keyword = this.data.keyword.replace(/\s/g, '').replace(/，/gi, ',');
  }

  changeKeyWord(val) {
    this.data.keyword = val;
  }

  renderContent(h: CreateElement): VNode {
    return (
      <div class="r-px-30 r-pt-20">
        <el-form label-width="120px" ref="keyForm" props={{ model: this.data }} label-position="left" rules={this.rule}>
          <el-form-item label="搜索关键词" prop="keyword">
            <el-input v-model={this.data.keyword} maxlength={this.data.type === 1 ? '100' : '12'} show-word-limit onBlur={() => this.blurText()} onChange={val => this.changeKeyWord(val)}></el-input>
            {this.data.type === 1 && (
              <span class="tip blockTip">
                <span class="text-red r-mr-8">*</span>多个关键字时，以逗号隔开
              </span>
            )}
          </el-form-item>
          <div class="icon-nav-item-edit">
            <el-form-item prop="desc">
              <LinkForm
                value={this.data.desc}
                empCode={+globalElement.Vm.$store.state.empCode}
                onInput={val => (this.data.desc = val)}
                state={1}
                sgId={+globalElement.Vm.$route.params.sgId}
                siteCodes={[globalElement.Vm.$route.params.code]}
                onChange={val => this.onLinkChange(val)}
                ref="linkForm"
                linkText="链接至"
                class="hot-ad-link"
                hotAd={false}
                hotarea={true}
                siteId={this.data.siteId}
                attributeList={this.connectedClass}
                exclude={[8, 12, 13, 14, 15, 16, 17, 18, 20]}
                mode={2}
                sortShow={true}
                dialogFooter={false}
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
    );
  }
}
